import { env } from '@prismo-io/env';
import { Wrapper } from './wrapper';

export const createTrackingClient = (
  apiKey: string = env.NEXT_PUBLIC_USERMAVEN_KEY
) => {
  return Wrapper();
};
